<wr-new-data-table headerText="Portfolioübersicht"
                   localStorageIdentifier="portfolio-overview"
                   [loadItemsFunction]="loadRows"
                   [getCountFunction]="getCount"
                   [defaultSort]="defaultSort"
                   (lineClick)="navigateTo($event)"
                   [form]="form">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-items">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Name, Adresse, Nummer...">
        </div>
        @if (isInternalTenant() && ownerTenantOptions().length > 1) {
          <div class="filter-control-group">
            <label class="label" for="ownerTenantFilter">Kunden</label>
            <nb-select id="ownerTenantFilter" formControlName="ownerTenantId" placeholder="Alle">
              <nb-option [value]="null">Alle</nb-option>
              @for (option of ownerTenantOptions(); track option.id) {
                <nb-option [value]="option.id">{{ option.name }}</nb-option>
              }
            </nb-select>
          </div>
        }
      </div>
    </form>
  </ng-template>

  <ng-template dataColumn let-row key="address" display="Adresse">
    {{ row.address }}
  </ng-template>

  <ng-template dataColumn let-row key="name" display="Name">
    {{ row.name }}
  </ng-template>

  <ng-template dataColumn let-row key="internalNumber" display="Int. Nummer">
    {{ row.internalNumber }}
  </ng-template>

  <ng-template dataColumn let-row key="heatPerArea" display="Wärme (kWh/m²·a)" [exportDecimals]="1">
    @if (row.heatPerArea != null) {
      {{ row.heatPerArea | number: '1.1-1' }}
    } @else {
      –
    }
  </ng-template>

  <ng-template dataColumn let-row key="coldWaterPerArea" display="Kaltwasser (l/m²·a)" [exportDecimals]="1">
    @if (row.coldWaterPerArea != null) {
      {{ row.coldWaterPerArea | number: '1.1-1' }}
    } @else {
      –
    }
  </ng-template>

  <ng-template dataColumn let-row key="electricityPerArea" display="Allgemeinstrom (kWh/m²·a)" [exportDecimals]="1">
    @if (row.electricityPerArea != null) {
      {{ row.electricityPerArea | number: '1.1-1' }}
    } @else {
      –
    }
  </ng-template>

  <ng-template dataColumn let-row key="solarSavingsPerArea" display="Solareinsparung (kWh/m²·a)" [exportDecimals]="1">
    @if (row.solarSavingsPerArea != null) {
      {{ row.solarSavingsPerArea | number: '1.1-1' }}
    } @else {
      –
    }
  </ng-template>

  <ng-template dataColumn let-row key="livingArea" display="BGF (m²)" [exportDecimals]="1">
    @if (row.livingArea != null) {
      {{ row.livingArea | number: '1.0-1' }}
    } @else {
      <span class="missing-hint" nbTooltip="Kein Energieausweis mit Brutto-Grundfläche (BGF) gepflegt.">
        kein Energieausweis
      </span>
    }
  </ng-template>
</wr-new-data-table>
